import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
export function PainSection() {
  const painPoints = ['Llegás a la cancha sin saber exactamente qué ejercicio vas a dar', 'Tus jugadores no progresan porque no hay una secuencia clara de contenidos', 'Tenés grupos con niveles mezclados y no sabés cómo manejarlos', 'Cuando hay feriado o partido perdés la continuidad del entrenamiento', 'No podés justificar un aumento de cuota porque "no tenés nada en papel"', 'El club no te da materiales y terminás poniendo plata de tu bolsillo', 'Nadie valora tu trabajo porque no lo ves reflejado en resultados concretos'];
  return <section className="w-full px-4 py-20 md:py-24 bg-bg-primary" data-id="element-189">
      <div className="max-w-4xl mx-auto" data-id="element-190">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-191">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-black leading-tight mb-8" data-id="element-192">
            Si sos entrenador de vóley, esto te va a sonar conocido:
          </h2>
        </motion.div>

        <div className="space-y-6 mb-12" data-id="element-193">
          {painPoints.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className="flex items-start gap-4 bg-bg-card border border-border-card rounded-card p-6" data-id="element-194">
              <X className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-195" />
              <p className="text-lg text-text-secondary" data-id="element-196">{point}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-197">
          <p className="text-2xl md:text-3xl font-bold text-orange" data-id="element-198">
            ¿Cuántos entrenamientos más vas a improvisar?
          </p>
        </motion.div>
      </div>
    </section>;
}